import React from 'react'

import { useAPIGetPerencanaanSummary } from 'api/kinerja/pengawas-sekolah/perencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import {
  useAPIGetSummary,
  useAPIGetStatus,
} from 'api/kinerja/pengawas-sekolah/landing-page'

export function usePSSummary({
  disabled = false,
}: {
  disabled?: boolean
} = {}) {
  const { period, isHavePeriod } = usePeriodContext()

  const { data: summary, status: summaryFetchStatus } = useAPIGetSummary({
    periodId: period.id,
    enabled: !disabled && isHavePeriod,
  })
  const isPelaksanaanState = ['PELAKSANAAN_DIMULAI'].includes(
    summary?.perencanaanStatus
  )

  // E-Kinerja Sync
  const isEkinSyncSuccess = ['RHK_CREATED', 'PERSETUJUAN_SUCCESS'].includes(
    summary?.ekinSyncStatus
  )
  const ekinSyncAt = React.useMemo(() => {
    if (
      !summary?.ekinSyncAt ||
      summary?.ekinSyncAt === '0001-01-01T00:00:00Z'
    ) {
      return null
    }

    return summary?.ekinSyncAt
  }, [summary?.ekinSyncAt])

  return {
    summary,
    summaryFetchStatus,
    isPelaksanaanState,
    isEkinSyncSuccess,
    ekinSyncAt,
  }
}

export function usePerencanaanPSSummary() {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: { data: perencanaan } = {}, status: apiStatus } =
    useAPIGetPerencanaanSummary({
      periodId: period.id,
      enabled: isHavePeriod,
    })
  return {
    perencanaan,
    apiStatus,
  }
}

export function usePSStatus({
  disabled = false,
}: {
  disabled?: boolean
} = {}) {
  const { period, isHavePeriod } = usePeriodContext()

  const { data: summary, status: summaryFetchStatus } = useAPIGetStatus({
    periodId: period.id,
    enabled: !disabled && isHavePeriod,
  })
  const isPelaksanaanState = ['PELAKSANAAN_DIMULAI'].includes(
    summary?.perencanaanStatus
  )

  return {
    summary,
    summaryFetchStatus,
    isPelaksanaanState,
  }
}
